<p-toast></p-toast>
<p-progressBar mode="indeterminate" *ngIf="isLoading || isScanning || isPrinting"></p-progressBar>

<app-page-shell>
  @if (dispatch) {
    <app-page-hero
      eyebrow="Warehousing"
      [title]="dispatch.dispatchNumber || 'Dispatch Scan'"
      [subtitle]="'Scanner execution for reserved stock units.'">
      <div actions class="flex gap-2 flex-wrap">
        <p-button label="Back to Dispatch" icon="pi pi-arrow-left" severity="secondary" [outlined]="true" [routerLink]="['/warehousing/dispatch/view', dispatch.id]" queryParamsHandling="preserve"></p-button>
        @if (supportsStockLedgerWorkflow()) {
          <p-button label="Print Selected" icon="pi pi-print" severity="secondary" [outlined]="true" [disabled]="!selectedUnitIds.size || isPrinting" (click)="printSelectedLabels()"></p-button>
          <p-button label="Print All Labels" icon="pi pi-tags" severity="secondary" [outlined]="true" [disabled]="isPrinting" (click)="printAllLabels()"></p-button>
        }
      </div>
    </app-page-hero>

    <app-page-metric-strip [metrics]="metrics()"></app-page-metric-strip>

    <app-page-form-section icon="pi pi-barcode" title="Scan Workflow" subtitle="Use a Zebra handheld or keyboard-wedge scanner to execute pick, stage, and load in order.">
      @if (!supportsStockLedgerWorkflow()) {
        <div class="surface-100 border-round p-3 text-700">
          Third-party virtual warehouses do not support dispatch scan workflows.
        </div>
      } @else if (!isGateOpen()) {
        <div class="surface-100 border-round p-3 text-700">
          Waiting for inbound transfer receipt before dispatch scanning can start.
        </div>
      } @else {
      <div class="flex flex-column gap-3">
        <div class="flex gap-2 flex-wrap">
          <p-button label="Pick" icon="pi pi-check-circle" [severity]="scanMode === 'pick' ? 'info' : 'secondary'" [outlined]="scanMode !== 'pick'" (click)="setScanMode('pick')"></p-button>
          <p-button label="Stage" icon="pi pi-warehouse" [severity]="scanMode === 'stage' ? 'warn' : 'secondary'" [outlined]="scanMode !== 'stage'" (click)="setScanMode('stage')"></p-button>
          <p-button label="Load" icon="pi pi-truck" [severity]="scanMode === 'load' ? 'success' : 'secondary'" [outlined]="scanMode !== 'load'" (click)="setScanMode('load')"></p-button>
        </div>
        <div class="formgrid grid">
          <div class="field col-12 md:col-9">
            <p-inputGroup>
              <p-inputGroupAddon><i class="pi pi-barcode"></i></p-inputGroupAddon>
              <p-iftaLabel>
                <input id="dispatchScanInput" pInputText [(ngModel)]="scanValue" [ngModelOptions]="{ standalone: true }" autofocus (keydown.enter)="submitScan()">
                <label for="dispatchScanInput">Scan Stock Unit Code</label>
              </p-iftaLabel>
            </p-inputGroup>
          </div>
          <div class="field col-12 md:col-3">
            <p-button [label]="'Scan ' + (scanMode | titlecase)" styleClass="w-full" [loading]="isScanning" [disabled]="isScanning || !isGateOpen()" (click)="submitScan()"></p-button>
          </div>
        </div>
        <div class="surface-100 border-round p-3">
          Dispatch lifecycle: <strong>{{ dispatch.lifecycleStatus || dispatch.status || '-' }}</strong>
        </div>
      </div>
      }
    </app-page-form-section>

    <app-page-form-section icon="pi pi-list" title="Reserved Units" subtitle="Track unit-level execution and reprint labels directly from reserved units.">
      <p-table [value]="reservationRows()" styleClass="p-datatable-sm p-datatable-gridlines warehousing-data-table" [tableStyle]="{ 'min-width': '76rem' }">
        <ng-template pTemplate="header">
          <tr>
            <th style="width: 4rem;">Pick</th>
            <th>Unit</th>
            <th>Item</th>
            <th>Warehouse</th>
            <th>Zone</th>
            <th>Condition</th>
            <th>Binding</th>
            <th>Provenance</th>
            <th>Status</th>
            <th>Picked</th>
            <th>Staged</th>
            <th>Loaded</th>
          </tr>
        </ng-template>
        <ng-template pTemplate="body" let-row>
          <tr>
            <td>
              <input type="checkbox" [checked]="isSelected(row.reservation.stockUnitId)" (change)="toggleUnitSelection(row.reservation.stockUnitId, $any($event.target).checked)">
            </td>
            <td>
              <div class="stack-cell">
                <span class="cell-title">{{ row.reservation.stockUnitCode || ('Unit #' + row.reservation.stockUnitId) }}</span>
                <span class="cell-meta">Qty {{ row.reservation.quantity | number:'1.0-4' }}</span>
              </div>
            </td>
            <td>{{ itemName(row.itemId) }}</td>
            <td>{{ masterName('WAREHOUSE', row.warehouseId) }}</td>
            <td>{{ masterName('ZONE', row.zoneId) }}</td>
            <td>{{ masterName('ITEM_CONDITION', row.conditionId) }}</td>
            <td>{{ reservationBindingLabel(row.reservation) }}</td>
            <td>{{ reservationSourceLabel(row.reservation) }}</td>
            <td><p-tag [value]="row.reservation.scanStatus || 'PENDING'" [severity]="statusSeverity(row.reservation.scanStatus || 'PENDING')"></p-tag></td>
            <td>{{ displayDateTime(row.reservation.pickedAt) }}</td>
            <td>{{ displayDateTime(row.reservation.stagedAt) }}</td>
            <td>{{ displayDateTime(row.reservation.loadedAt) }}</td>
          </tr>
        </ng-template>
        <ng-template pTemplate="emptymessage">
          <tr><td colspan="12"><div class="warehousing-empty-state"><i class="pi pi-search"></i><strong>No reserved units</strong><span>Reserve dispatch stock before using the scan workflow.</span></div></td></tr>
        </ng-template>
      </p-table>
    </app-page-form-section>
  } @else if (!isLoading) {
    <div class="warehousing-empty-detail">
      <i class="pi pi-search"></i>
      <strong>Dispatch not found</strong>
      <span>The selected dispatch could not be loaded.</span>
    </div>
  }
</app-page-shell>
